import React from 'react';
import { Link } from 'react-router-dom';
import './PersonalCare.css';

function VirtualTherapist() {
  return (
    <div className="personal-care-page">
      <header className="header">
        <nav className="navbar">
          <div className="logo">
            <Link to="/"><h1>Malach <span>Healthcare</span></h1></Link>
          </div>
          <ul className="nav-links">
            <li><Link to="/">Home</Link></li>
            <li><Link to="/#services">Services</Link></li>
            <li><Link to="/#contact">Contact</Link></li>
          </ul>
          <Link to="/#contact" className="btn btn-primary">Book Consultation</Link>
        </nav>
      </header>

      <section className="service-hero">
        <div className="service-hero-content">
          <h1>Virtual Talk Therapist</h1>
          <p>Professional counseling and emotional wellness support — from the comfort of your home</p>
        </div>
      </section>

      <section className="service-content">
        <div className="service-intro">
          <h2>Your Mental Health Matters</h2>
          <p>
            Caring for the body is only part of what Malach Healthcare does. We understand that emotional
            well-being is equally important — especially for seniors, those recovering from illness, and
            family caregivers who often carry the heaviest emotional load.
          </p>
          <p>
            Our Virtual Talk Therapist service connects you with licensed mental health professionals via
            secure video sessions — no travel needed, no waiting rooms, just meaningful conversation and
            professional support at a time that works for you.
          </p>
        </div>

        <div className="services-list">
          <h2>What Our Virtual Therapy Sessions Cover</h2>
          <div className="services-grid-detail">
            <div className="service-item">
              <div className="service-item-icon">😔</div>
              <h3>Depression & Anxiety</h3>
              <p>Evidence-based support for managing low mood, worry, and emotional distress</p>
            </div>
            <div className="service-item">
              <div className="service-item-icon">🧓</div>
              <h3>Aging & Life Transitions</h3>
              <p>Coping with retirement, loss of independence, and major life changes</p>
            </div>
            <div className="service-item">
              <div className="service-item-icon">💔</div>
              <h3>Grief & Loss</h3>
              <p>Compassionate guidance through bereavement and the loss of loved ones</p>
            </div>
            <div className="service-item">
              <div className="service-item-icon">👨‍👩‍👧</div>
              <h3>Family & Caregiver Support</h3>
              <p>Helping family caregivers manage stress, burnout, and difficult emotions</p>
            </div>
            <div className="service-item">
              <div className="service-item-icon">🏥</div>
              <h3>Chronic Illness Adjustment</h3>
              <p>Emotional support for those adapting to long-term health conditions</p>
            </div>
            <div className="service-item">
              <div className="service-item-icon">💬</div>
              <h3>Talk Therapy & Counseling</h3>
              <p>One-on-one sessions focused on listening, understanding, and coping strategies</p>
            </div>
          </div>
        </div>

        <div className="caregivers-section">
          <h2>How It Works</h2>
          <p>
            Simply book a free consultation and we'll match you with a licensed therapist suited to your
            needs. Sessions are conducted via secure, easy-to-use video conferencing — all you need is a
            phone, tablet, or computer. Sessions can be scheduled at flexible times to fit your routine.
          </p>
        </div>

        <div className="why-choose-us">
          <h2>Why Choose Malach Virtual Therapy?</h2>
          <ul className="benefits-list">
            <li>✓ Licensed and experienced therapists</li>
            <li>✓ Convenient — no travel, no waiting rooms</li>
            <li>✓ Confidential and secure video sessions</li>
            <li>✓ Flexible scheduling including evenings and weekends</li>
            <li>✓ Specialized in senior mental health and caregiver support</li>
          </ul>
        </div>

        <div className="closing-message">
          <p>
            You don't have to face life's challenges alone. Our therapists are here to listen, support,
            and walk alongside you.
          </p>
          <Link to="/#contact" className="btn btn-primary btn-large">Book a Virtual Session</Link>
        </div>
      </section>

      <footer className="footer">
        <div className="footer-container">
          <div className="footer-section">
            <h3>Malach <span>Healthcare</span></h3>
            <p>Empowering golden years with compassionate care.</p>
          </div>
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/#services">Services</Link></li>
              <li><Link to="/#contact">Contact</Link></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Contact Info</h4>
            <p>📍 740 Main St, Waltham, MA 02451</p>
            <p>📞 (781) 697-6330</p>
            <p>✉️ info@malachhealthcare.com</p>
          </div>
        </div>
        <div className="footer-bottom">
          <p>Copyright © 2025 | All Rights Reserved | Malach Healthcare</p>
        </div>
      </footer>
    </div>
  );
}

export default VirtualTherapist;
